React = require('react')

Footer = React.createClass
  propTypes:
    title: React.PropTypes.string
  render: ->
    React.createElement("footer", {"className": 'pb2'},
      React.createElement("ul", {"className": 'list-reset'},
        React.createElement("li", {"className": "inline-block mr1"},
          React.createElement("a", {"href": 'http://www.vvh.io', "className": 'text-decoration-none mdl-button mdl-js-button mdl-button mdl-js-ripple-effect mdl-button--fab'}, React.createElement("i", {"className": "material-icons md-light"}, "info outline"))
        )
      )
    )

module.exports = Footer



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./app/components/Footer.cjsx
 **/